import React from 'react';
type CaprelsaWordmarkProps = {
  size?: 'sm' | 'lg';
  className?: string;
};

/** Stand-in for the Caprelsa® logo (gold figure swoosh + purple wordmark) — replace with the official ESTEVE asset. */
export function CaprelsaWordmark({
  size = 'sm',
  className = ''
}: CaprelsaWordmarkProps) {
  const big = size === 'lg';
  return <span className={`inline-flex items-end leading-none ${className}`} aria-label="Caprelsa (vandetanib)" data-id="element-423" data-mp="23oaf485bwaw">
      <svg viewBox="0 0 40 34" className={big ? 'mr-1 h-[46px] w-[54px]' : 'mr-0.5 h-[20px] w-[24px]'} aria-hidden="true" data-id="element-424" data-mp="zplrcx6vntkq">
        <path d="M2 30 C 6 14, 20 6, 36 8 C 24 10, 12 16, 6 30 Z" fill="#d6a530" data-id="element-425" data-mp="utehwuf9vzy1" />
        <path d="M14 22 C 18 16, 24 13, 30 13 C 25 15, 20 18, 17 24 Z" fill="#e5862d" data-id="element-426" data-mp="pyhd5zp10cqy" />
        <circle cx="30" cy="4.5" r="3.6" fill="#e5862d" data-id="element-427" data-mp="l0piwz0wsejl" />
      </svg>
      <span className="flex flex-col" data-id="element-428" data-mp="1igwcexpx9c4p">
        <span className={`font-extrabold tracking-[-0.02em] text-cap-purple ${big ? 'text-[42px]' : 'text-[18px]'}`} data-id="element-429" data-mp="1ihxq79ybocq4">
          Caprelsa<sup className="ml-0.5 align-super text-[0.4em]" data-id="element-430" data-mp="2x3by9qe7jyee">®</sup>
        </span>
        <span className={`font-medium text-cap-grey ${big ? 'mt-0.5 text-[15px]' : 'text-[8.5px]'}`} data-id="element-431" data-mp="2x5gcp29qgfsx">(vandetanib) tablets</span>
      </span>
    </span>;
}